import AdvertContextProvider from "./AdvertContext";
import AuthContextProvider from "./AuthContext";
import ContactRequestContextProvider from "./ContactRequestContext";
import HomeSectionsContextProvider from "./HomeSectionsContext";
import ImageResourcesContextProvider from "./ImageResourcesContext";
import LoadingContextProvider from "./LoadingContext";
import NavContextProvider from "./NavContext";
import PropertyContextProvider from "./PropertyContext";
import UserContextProvider from "./UserContext";

const ContextProvider = (prop) => {
	return (
		<AuthContextProvider>
			<LoadingContextProvider>
				<NavContextProvider>
					<PropertyContextProvider>
						<UserContextProvider>
							<HomeSectionsContextProvider>
								<AdvertContextProvider>
									<ContactRequestContextProvider>
										<ImageResourcesContextProvider>
											{prop.children}
										</ImageResourcesContextProvider>
									</ContactRequestContextProvider>
								</AdvertContextProvider>
							</HomeSectionsContextProvider>
						</UserContextProvider>
					</PropertyContextProvider>
				</NavContextProvider>
			</LoadingContextProvider>
		</AuthContextProvider>
	);
};

export default ContextProvider;
